module.exports = __webpack_public_path__ + "img/c04_unitmangonelgalleychampion_Normal_ua.9bf97f73.webp";